import { BadgeOption } from 'src/types';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { PRICING_OVERRIDE_STATUS } from 'src/features/subscriptionItemPricingOverrides/utils/types';

// The three version states read the same here as on a plan policy, so they reuse those labels
// rather than duplicating three translation strings.
export const PRICING_OVERRIDE_STATUS_BADGE_OPTIONS: Record<PRICING_OVERRIDE_STATUS, BadgeOption> = {
    [PRICING_OVERRIDE_STATUS.CURRENT]: {
        label: billingPoliciesMessages.current,
        theme: 'green',
        icon: ICON_MAP.CURRENT,
    },
    [PRICING_OVERRIDE_STATUS.PAST]: {
        label: billingPoliciesMessages.past,
        theme: 'red',
        icon: ICON_MAP.PAST,
    },
    [PRICING_OVERRIDE_STATUS.SCHEDULED]: {
        label: billingPoliciesMessages.scheduled,
        theme: 'orange',
        icon: ICON_MAP.SCHEDULED,
    },
};
